import axios from 'axios';

const API_BASE = '/api';

// In-memory only — never persisted, so a page refresh always requires a fresh login.
let _token = null;
export const getToken = () => _token;
export const setToken = (t) => { _token = t; };

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use(config => {
  if (_token) config.headers.Authorization = `Bearer ${_token}`;
  return config;
});

client.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      setToken(null);
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export const login = (username, password) => {
  const form = new FormData();
  form.append('username', username);
  form.append('password', password);
  return client.post('/auth/login', form);
};

export const getProducts = () => client.get('/products/');
export const addProduct = (asin, amazon_url) => client.post('/products/', null, { params: { asin, amazon_url } });
export const updateProduct = (id, data) => client.patch(`/products/${id}`, data);
export const deleteProduct = (id) => client.delete(`/products/${id}`);
export const getForex = () => client.get('/products/forex');
export const getPriceHistory = (id) => client.get(`/products/history/${id}`);
export const getKeepaHistory = (id) => client.get(`/products/keepa-history/${id}`);

export const getForexSettings = () => client.get('/settings/forex');
export const updateForexSettings = (data) => client.put('/settings/forex', data);

export const getTelegramSettings = () => client.get('/settings/telegram');
export const updateTelegramSettings = (data) => client.put('/settings/telegram', data);
export const getApiKeys = () => client.get('/settings/apikeys');
export const updateApiKeys = (data) => client.put('/settings/apikeys', data);

export const exportExcel = (type) => client.get('/data/export', {params:{type}, responseType:'blob'});
export const previewImport = (file) => { const fd = new FormData(); fd.append('file', file); return client.post('/data/import/preview', fd); };
export const commitImport  = (data) => client.post('/data/import/commit', data);
export const getSnapshots  = ()     => client.get('/data/snapshots');
export const createSnapshot= (name) => client.post('/data/snapshots', {name});
export const restoreSnapshot=(id)   => client.post('/data/snapshots/'+id+'/restore');
export const deleteSnapshot = (id)  => client.delete('/data/snapshots/'+id);

export const verifyLive = (id) => client.post('/products/'+id+'/verify-live');
export const getLiveData = () => client.get('/products/live-data');

export default client;
